import {
  fileTypeValidator,
  maxNumberOfColoursValidator,
  spotColorsValidator,
  resolutionValidator,
  gradientFileValidator,
} from './index';
import { ProductPrintPositionBoxModel } from '@/typings';
import { AnnotationShape } from '../web-components/import-wizard/typings/pintura';
import _flow from 'lodash.flow';
import {
  PrintTechnique,
  ProductPrintPosition,
} from '@midocean/webapps-shared-domain';

export const constructArtworkValidationPipeline = (
  productPrintData: any,
  selectedPrintPositions: ProductPrintPositionBoxModel[],
  shapes: AnnotationShape[],
  shape: AnnotationShape,
  checkMaxNoOfColors = true
): any => {
  // This array is reinitialized each time an Import of an shape to the wizard has been requested
  const validators = [];
  for (const {
    id: printPositionId,
    techniqueId: printTechniqueId,
    techniqueName: techniqueName,
  } of selectedPrintPositions) {
    if (shape.kind === 'Logo') {
      const activePrintPosition = productPrintData.productPrintPositions.find(
        (p: ProductPrintPosition) => printPositionId === p.id
      );
      const activePrintTechnique = activePrintPosition?.printTechniques.find(
        (t: PrintTechnique) =>
          printTechniqueId === t.printTechnique.id || printTechniqueId === t.id
      );

      // Dynamically adding validators to the validation
      for (const logoValidator of activePrintTechnique.logoValidators) {
        if (logoValidator.type.trim() === 'FileType') {
          validators.push(
            fileTypeValidator(
              logoValidator.configuration,
              shape,
              printPositionId
            )
          );
        }

        if (
          logoValidator.type.trim() === 'Resolution' &&
          shape.kind === 'Logo' &&
          !shape.isVectorFileTrueVectorFile &&
          shape.pngHorizontalResolutionDPIs &&
          shape.pngVerticalResolutionDPIs
        ) {
          validators.push(
            resolutionValidator(
              logoValidator.configuration,
              shape,
              printPositionId
            )
          );
        }

        if (logoValidator.type.trim() === 'SpotColorsIncluded') {
          validators.push(spotColorsValidator(shape, printPositionId));
        }
        // *This is where you will add and configured your validator into the pipeline
        // if(logoValidator.type.trim() === 'SOME_VALIDATOR_TYPE_VALUE'){}
      }

      if (checkMaxNoOfColors) {
        validators.push(
          maxNumberOfColoursValidator(
            shapes,
            activePrintTechnique.maximumColours,
            printPositionId
          )
        );
      }

      if (shape.hasGradient) {
        validators.push(
          gradientFileValidator(
            shape,
            printPositionId,
            !activePrintTechnique.printTechnique.isFullColor
          )
        );
      }
    }
  }

  return _flow(validators);
};
